import React, { CSSProperties } from 'react';
import './StatusBadge.scss';
import { Badge } from 'react-bootstrap';
import statusCodes, {
  StatusCodeForType,
  StatusItem,
  StatusType,
} from './statusCodes';

interface StatusBadgeProps<T extends StatusType> {
  type: T;
  statusCode: StatusCodeForType<T>;
  customClasses?: string;
}

function StatusBadge<T extends StatusType>({
  statusCode,
  type,
  customClasses,
}: StatusBadgeProps<T>) {
  const currentStatus = statusCodes[type][statusCode] as StatusItem;

  return (
    <Badge
      bg="custom"
      className={`${
        customClasses !== undefined
          ? customClasses
          : 'd-flex align-items-center ms-2'
      }`}
      style={
        {
          '--badge-color': `var(--bs-${currentStatus.color})`,
          '--badge-bg': `var(--bs-box-shadow-${currentStatus.color})`,
        } as CSSProperties
      }
    >
      {currentStatus.label}
    </Badge>
  );
}

export default StatusBadge;
